import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useForgotPasswordApi } from '../../hooks/useForgotPasswordApi';

export const useForgotPassword = () => {
  //   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createForgotPassword } = useForgotPasswordApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createForgotPassword(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Reset email or SMS sent successfully',
        'success'
      );
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Failed to login', 'error');
    },
  });
};
